import type { BaseAction, CatalogOption, ClusterOption, SchemaDataItem } from '../../types/redux';
import {
  EDITOR_ERROR,
  EDITOR_LOADING,
  EDITOR_REMOVE_SCHEMA_DATA,
  EDITOR_RESET_CATALOG_DATA,
  EDITOR_RESET_COMMON_EDITOR_PARA,
  EDITOR_SET_CATALOG_OPTIONS,
  EDITOR_SET_CLUSTER_OPTIONS,
  EDITOR_SET_SCHEMA_CHILDREN,
  EDITOR_SET_SCHEMA_DATA,
  EDITOR_UPDATE_CLUSTER_STATUS,
  EDITOR_UPDATE_DB_SUG_LIST,
} from './types';

export interface EditorLoadingAction extends BaseAction {
  type: typeof EDITOR_LOADING;
  loading: boolean;
}

export interface SetEditorCatalogOptionsAction extends BaseAction {
  type: typeof EDITOR_SET_CATALOG_OPTIONS;
  data: CatalogOption[];
}

export interface SetEditorClusterOptionsAction extends BaseAction {
  type: typeof EDITOR_SET_CLUSTER_OPTIONS;
  data: ClusterOption[];
}

export interface UpdateEditorClusterStatusAction extends BaseAction {
  type: typeof EDITOR_UPDATE_CLUSTER_STATUS;
  data: {
    uuid: string;
    status: string;
    is_deleted?: boolean;
    err?: string;
  };
}

export interface EditorErrorAction extends BaseAction {
  type: typeof EDITOR_ERROR;
  data: unknown;
}

export interface EditorUpdateDbSugListAction extends BaseAction {
  type: typeof EDITOR_UPDATE_DB_SUG_LIST;
  data: unknown;
  key: string;
  catID: string;
  dbKey?: string;
}

export interface SetEditorSchemaDataAction extends BaseAction {
  type: typeof EDITOR_SET_SCHEMA_DATA;
  data: SchemaDataItem[];
}

export interface EditorUpdateSchemaDataAction extends BaseAction {
  type: typeof EDITOR_SET_SCHEMA_CHILDREN;
  data: {
    key?: string;
    tableId?: string;
    catalogId?: string;
    id?: string;
    children?: SchemaDataItem[];
    type?: string;
  };
}

export interface RemoveEditorSchemaDataAction extends BaseAction {
  type: typeof EDITOR_REMOVE_SCHEMA_DATA;
  data: string[];
}

export interface ResetEditorCatalogDataAction extends BaseAction {
  type: typeof EDITOR_RESET_CATALOG_DATA;
  catId: string;
}

export interface ResetCommonEditorParaAction extends BaseAction {
  type: typeof EDITOR_RESET_COMMON_EDITOR_PARA;
}

export type EditorParaAction =
  | EditorLoadingAction
  | SetEditorCatalogOptionsAction
  | SetEditorClusterOptionsAction
  | UpdateEditorClusterStatusAction
  | EditorErrorAction
  | EditorUpdateDbSugListAction
  | SetEditorSchemaDataAction
  | EditorUpdateSchemaDataAction
  | RemoveEditorSchemaDataAction
  | ResetEditorCatalogDataAction
  | ResetCommonEditorParaAction;

export function editorLoading(isLoading: boolean): EditorLoadingAction {
  return {
    type: EDITOR_LOADING,
    loading: isLoading,
  };
}

export const setEditorCatalogOptions = (data: CatalogOption[]): SetEditorCatalogOptionsAction => {
  return {
    type: EDITOR_SET_CATALOG_OPTIONS,
    data,
  };
};

export function setEditorClusterOptions(data: ClusterOption[]): SetEditorClusterOptionsAction {
  return {
    type: EDITOR_SET_CLUSTER_OPTIONS,
    data: data,
  };
}

export function updateEditorClusterStatus(data: {
  uuid: string;
  status: string;
  is_deleted?: boolean;
  err?: string;
}): UpdateEditorClusterStatusAction {
  return {
    type: EDITOR_UPDATE_CLUSTER_STATUS,
    data,
  };
}

export function editorError(data: unknown): EditorErrorAction {
  return {
    type: EDITOR_ERROR,
    data: data,
  };
}

export const editorUpdateDbSugList = (
  data: unknown,
  key: string,
  catID: string,
  dbKey?: string
): EditorUpdateDbSugListAction => {
  return {
    type: EDITOR_UPDATE_DB_SUG_LIST,
    data,
    key,
    catID,
    dbKey,
  };
};

export function setEditorSchemaData(data: SchemaDataItem[]): SetEditorSchemaDataAction {
  return {
    type: EDITOR_SET_SCHEMA_DATA,
    data,
  };
}

export function editorUpdateSchemaData(data: {
  key?: string;
  tableId?: string;
  catalogId?: string;
  id?: string;
  children?: SchemaDataItem[];
  type?: string;
}): EditorUpdateSchemaDataAction {
  return {
    type: EDITOR_SET_SCHEMA_CHILDREN,
    data,
  };
}

export function removeEditorSchemaData(data: string[]): RemoveEditorSchemaDataAction {
  return {
    type: EDITOR_REMOVE_SCHEMA_DATA,
    data,
  };
}

export const resetEditorCatalogData = (catId: string): ResetEditorCatalogDataAction => {
  return {
    type: EDITOR_RESET_CATALOG_DATA,
    catId,
  };
};

export function resetCommonEditorParaOptions(): ResetCommonEditorParaAction {
  return {
    type: EDITOR_RESET_COMMON_EDITOR_PARA,
  };
}
